import { connect } from 'react-redux'
import PageMarketingPage from '../../components/PageMarketing/PageMarketingPage';
import config from '../../config.json'
import toJS from '../general/toJS.js';
import { AUTH, FEATURES } from '../../constants/state.js';
import getData from '../../functions/getData'

const mapStateToProps = state => ({
    webToPrintRoutes: state.getIn(['wpServerData', 'data', 'data', 'webtoprint']),
    routes:           state.getIn(['wpServerData', 'data', 'data', 'routes']),
    caps:                        state.getIn([AUTH, 'caps']),
    hasSocialMediaPostGenerator: !!getData(state, [FEATURES, 'has_social_media_post_generator']),
})

const PageMarketing = ({saveState, status, webToPrintRoutes, routes, caps, hasSocialMediaPostGenerator}) => {
    let usedWebToPrintRoutes = []

    if(webToPrintRoutes) {
        if(webToPrintRoutes.flyer || webToPrintRoutes.showcase || webToPrintRoutes.weekposter) {
            usedWebToPrintRoutes.push('showcaseprint')
        }
        if(webToPrintRoutes.newsletter && caps.newsletterDataGet) {
            usedWebToPrintRoutes.push('newsletter')
        }
    }
    if(hasSocialMediaPostGenerator && routes && routes.socialmediapostgenerator && caps.socialMediaDataGet) {
        usedWebToPrintRoutes.push('socialMedia')
    }
    return (
        <PageMarketingPage
            pageName={config.routes.marketing.name}
            saveState={saveState}
            usedWebToPrintRoutes={usedWebToPrintRoutes}
            status={status}
        />
    )
}

export default connect(mapStateToProps)(toJS(PageMarketing))